import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import type { BaseQueryFn, FetchArgs, FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { RootState } from '../index';
import { API_BASE_URL } from '@/utils/constants';

// Custom base query with error handling and token injection
const baseQuery = fetchBaseQuery({
  baseUrl: API_BASE_URL || process.env.NEXT_PUBLIC_API_URL || 'http://localhost:3000',
  prepareHeaders: (headers, { getState }) => {
    // Get token from state if available
    const token = (getState() as RootState).auth?.token;
    
    if (token) {
      headers.set('authorization', `Bearer ${token}`);
    }
    
    headers.set('Content-Type', 'application/json');
    return headers;
  },
});

// Base query with re-authentication logic
const baseQueryWithReauth: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError
> = async (args, api, extraOptions) => {
  let result = await baseQuery(args, api, extraOptions);
  
  if (result.error && result.error.status === 401) {
    // Try to get a new token here if you have refresh token logic
    // const refreshResult = await baseQuery('/refreshToken', api, extraOptions);
    // if (refreshResult.data) {
    //   // store the new token
    //   result = await baseQuery(args, api, extraOptions);
    // } else {
    //   // logout user or handle refresh failure
    // }
  }
  
  return result;
};

// Create the main API slice
export const apiSlice = createApi({
  reducerPath: 'api',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['User', 'Product', 'Order', 'Category', 'FAQ'], // Add your tag types here
  endpoints: () => ({}),
});
